import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-nextgen";
import { ToastContainer } from "react-toastify";
import ImageBackground from '../../Assets/Images/background-login.jfif';
import ImageBackgroundMobile from '../../Assets/Images/background-mobile.jpeg';
import CustomerInfo from "./cus-info";
import LoginCustomer from "../login/login-customer"
import * as CustomerService from '../../Services/customer-service';
import _ from "lodash";
import useWindowDimensions from "../../Components/useWindowDimension";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import FooterCustomer from "../../Layouts/footer/FooterCustomer";
import '../../Assets/Styles/Customer/customer.css'
import RegisterCustomer from "../login/register-customer";
import ForgetPasswordCustomer from "../login/forget-password-customer";
import { countTimeExpired } from "../../Services/service";

function Customer() {
    const { height, width } = useWindowDimensions();
    const [loading, setLoading] = useState(false);
    const [objectDto, setObjectDto] = useState(() => {
        const savedCustomer = localStorage.getItem("aaa");
        return savedCustomer ? JSON.parse(savedCustomer) : {};
    });
    const { i18n } = useTranslation();
    const [stateLogin, setStateLogin] = useState(
        sessionStorage.getItem("state") != null ? sessionStorage.getItem("state") : "0");
    useEffect(() => {
    }, [i18n]);
    CustomerService.ManageCustomer(objectDto, setObjectDto);
    countTimeExpired(objectDto, setObjectDto);
    const styled_section = _.isEmpty(objectDto) || objectDto.fullName === undefined ?
        {
            padding: "0px",
            backgroundImage: width <= 480 ? `url(${ImageBackgroundMobile})` : `url(${ImageBackground})`,
            backgroundPosition: width <= 480 ? '' : 'center',
            backgroundSize: width <= 480 ? '100vw 100vh' : 'cover',
            backgroundRepeat: 'no-repeat',
            width: '100vw',
            height: width <= 480 ? "100vh" : height,
            overflow: "none"
        } : {
            width: width,
            height: height,
            padding: "0px"
        }
    return (
        <LoadingOverlay className="loading_overlay_content_customer" active={loading} spinner text={t("loading")} >
            <ToastContainer newestOnTop={true} autoClose={15000} />
            {
                objectDto.fullName !== undefined ?
                    <CustomerInfo objectDto={objectDto} setObjectDto={setObjectDto} height={height} width={width} />
                    :
                    <section className="container" style={styled_section}>
                        {
                            stateLogin === "0" ?
                                <LoginCustomer setObjectDto={setObjectDto} objectDto={objectDto} setLoading={setLoading} setState={setStateLogin} /> :
                                stateLogin === "1" ?
                                    <RegisterCustomer setObjectDto={setObjectDto} objectDto={objectDto} setLoading={setLoading} setState={setStateLogin} /> :
                                    <ForgetPasswordCustomer setObjectDto={setObjectDto} objectDto={objectDto} setLoading={setLoading} setState={setStateLogin} />
                        }

                    </section>
            }
            <FooterCustomer />
        </LoadingOverlay>
    );
}

export default Customer